import { LoadingSpinner } from '@idexx-laboratories/spot-react';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useStore } from '../../hooks/use-store';
import './Callback.scss';

const Callback = observer(() => {
  const store = useStore().globalStore;

  useEffect(() => {
    store.loggingOut = false;
  }, [store]);

  return (
    <div className='loading-container'>
      <div>
        <h1>Please Wait. You are being redirected...</h1>
        <LoadingSpinner size='large' />
      </div>
    </div>
  );
});

export default Callback;
